import {useCallback} from "react";

const useTickerMenu = (portfolioTimeSeries, benchmarkTimeSeries, extraTimeseries, addTimeseriesSymbols, removeTimeseriesSymbols) => {

    const onPlotHoldings = useCallback((selectedTickers) => {
        const currentTimeseriesSymbols = new Set([
            ...portfolioTimeSeries, ...benchmarkTimeSeries, ...extraTimeseries
        ].map(series => series.symbol));
        const symbolsToAdd = selectedTickers.filter(symbol => !currentTimeseriesSymbols.has(symbol));
        const symbolsToRemove = [...currentTimeseriesSymbols].filter(symbol => !selectedTickers.includes(symbol));

        if (symbolsToAdd.length > 0) {
            addTimeseriesSymbols(symbolsToAdd);
        }
        if (symbolsToRemove.length > 0) {
            removeTimeseriesSymbols(symbolsToRemove);
        }
    }, [portfolioTimeSeries, benchmarkTimeSeries, extraTimeseries, addTimeseriesSymbols, removeTimeseriesSymbols]);

    return {
        onPlotHoldings,
    };
};

export default useTickerMenu;